import { ReportImg } from "@/components/report/commons/ReportImg";
import SleepDiaryChart from "@/components/report/commons/SleepDiaryChart";
import { MeasuredData } from "@/components/worksheet/commons/measured_data";
import { Stack, Typography } from "@mui/material";

interface MeasuredDataSectionProps {
  measuredData: MeasuredData[];
  paddingLeft: string;
}
export default function MeasuredDataSection({
  measuredData,
  paddingLeft,
}: MeasuredDataSectionProps) {
  if (measuredData.length === 0) {
    return <></>;
  } else {
    return (
      <>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ width: "100%" }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
            デバイス測定データ
          </Typography>
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={4}
            sx={{ height: "24px" }}
          >
            <Stack direction="row" sx={{ gap: "4px" }}>
              <ReportImg
                image_name="image_report_how_to_view_graphs_light_off.svg"
                width="8px"
              />
              <Typography variant="body2">消灯</Typography>
            </Stack>
            <Stack direction="row" sx={{ gap: "4px" }}>
              <ReportImg
                image_name="image_report_how_to_view_graphs_wake_up.svg"
                width="8px"
              />
              <Typography variant="body2">起床</Typography>
            </Stack>
            <Stack direction="row" sx={{ gap: "4px" }}>
              <ReportImg
                image_name="image_report_how_to_view_graphs_sleep.svg"
                width="8px"
              />
              <Typography variant="body2">睡眠</Typography>
            </Stack>
            <Stack direction="row" sx={{ gap: "4px" }}>
              <ReportImg
                image_name="image_report_how_to_view_graphs_mid-awakening.svg"
                width="8px"
              />
              <Typography variant="body2">睡眠中の覚醒</Typography>
            </Stack>
            <Stack direction="row" sx={{ gap: "4px" }}>
              <ReportImg
                image_name="image_report_how_to_view_graphs_nap.svg"
                width="8px"
              />
              <Typography variant="body2">仮眠（自己申告）</Typography>
            </Stack>
          </Stack>
        </Stack>

        <Stack direction="row" sx={{ width: "100%" }}>
          <Stack sx={{ width: paddingLeft }} />
          <Stack sx={{ width: "100%", height: "471px" }}>
            <SleepDiaryChart
              data={measuredData.map((d) => ({
                date: d.date,
                bedtime: d.bedtime == null ? null : new Date(d.bedtime),
                ariseTime: d.arise_time == null ? null : new Date(d.arise_time),
                sleepData: d.chart_data.map((c) => ({
                  from: new Date(c.from),
                  to: new Date(c.to),
                  type: c.type,
                })),
              }))}
            />
          </Stack>
        </Stack>
      </>
    );
  }
}
